import { NgModule } from '@angular/core';
import { BtnToggleComponent } from '../components/btn-toggle.component';

@NgModule({
  declarations: [
    BtnToggleComponent
  ],
  imports: [
  ],
  exports: [
    BtnToggleComponent
  ]
})
export class BtnToggleModule { }